import { Component, NgZone, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { CustomerSupportService } from '../services/customer-support.service';
import { Select2Option } from '../../shared/select2-option';
import { MessageService } from '../../shared/message.service';
import { getAlertMessage } from '../../shared/api-loaders';
import { Alert } from '../../shared/alert.model';
import { ModalService } from '../../shared/modal.service';
import { CustomerService } from '../../ect-feature/services/customer.service';
import { SecurityService } from '../../shared/security.service';
import { environment } from '../../../environments/environment';
import { PlatformIdmService } from '@platform-idm/sdk-angular'; 

@Component({
    selector: 're-customer-selection-modal-dialog',
    templateUrl: './customer-selection-modal-dialog.component.html',
    styleUrls: ['./customer-selection-modal-dialog.component.scss'],
    standalone: false
})
export class CustomerSelectionModalDialogComponent implements OnInit {
  public static show(modalService: ModalService) {
    let dialog = modalService.create<CustomerSelectionModalDialogComponent>(CustomerSelectionModalDialogComponent, {
      keyboard: false //no ESC
    });
    return dialog
  }
  constructor(private customerService: CustomerService, private messages: MessageService, private customerSupportService: CustomerSupportService, private activeModal: NgbActiveModal, private router: Router, private ngZone: NgZone, private securityService: SecurityService, private auth: PlatformIdmService) { }

  ngOnInit(): void {
    //customers api
    this.processing = true;
    this.customerService.getCustomersByStack().subscribe({
      next: x => {
        this.customers = x.map<Select2Option>(c => (
          {
            text: `${c.accountId} ${c.accountName} (${c.idpType || 'No IDP'})`,
            id: c.accountId, data: c,
            disabled: c.idpType?.toLowerCase() != "okta",
          }));
        let c = this.customerSupportService.getSelectedCustomer();
        if (c) {
          this.selectedCustomer = c.accountId;
        }
        this.processing = false;
      },
      error: err => {
        this.processing = false;
        this.alert = getAlertMessage(err);
      }
    });

  }
  alert: Alert;

  customers: Select2Option[];
  selectedCustomer: string
  processing = false;
  async accept() {
    //impersonate api
    this.processing = true;
    let selectedOption = this.customers.firstOrDefault(x => x.id == this.selectedCustomer);
    if (!selectedOption) {
      this.messages.sendError(`Customer Id ${this.selectedCustomer} not found.`);
      return;
    }
    //lets try the new method of handling errors, since subscribe with seocnd argument will be depracted
    this.customerSupportService.saveCustomer(selectedOption.data).subscribe({
      next: async () => {
          this.auth.authentication.refreshToken(true, x => {
            window.location.href = "/users";
          });
      },
      error: (err) => {
        //looks like updates inside the bootrap modal are not immediatlly updated. So lets do tha  manually with ngzone
        this.ngZone.run(() => {
          this.processing = false;
          this.alert = getAlertMessage(err);
        });

      }
    });
  }


  navigateToHomeOnCancel = true;
  close() {
    if (this.navigateToHomeOnCancel) {
      this.securityService.navigateToHome();
    }
    this.activeModal.close(false);
  }

}
